import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import colors from "../../assest/theme/base/colors";
import MaterialButton from "../../components/MaterialButton";

const ConfirmDialog = ({ open, title, content, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          width: "600px", // Set your desired width
          maxWidth: "none", // Prevent it from limiting the width to default sizes
          p:2,
          borderRadius: "25px",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2 }}>
        <CloseIcon
          onClick={onClose}
          fontSize="50px"
          sx={{ color: colors.black.main, fontSize: "30px", cursor:"pointer" }}
        />
      </Box>
      <DialogTitle
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          color:"#130175"
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          fontWeight: "300",
          textAlign: "center",
          color:"#130175"
        }}
      >
        {content}
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <MaterialButton variant="contained" sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }} onClick={onConfirm}>
          Proceed
        </MaterialButton>
        <MaterialButton variant="outlined" color="error" onClick={onClose}>
          Cancel
        </MaterialButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
